<template>
  <button :class="buttonCss" :disabled="disabled" ref="button" type="submit">
    <icon :name="icon" class="uk-margin-small-right" v-if="icon" />
    <slot>{{textOrDefault}}</slot>
  </button>
</template>

<script>
import Button from '@/mixins/Button';
import DynamicProps from '@/mixins/DynamicProps';

export default {
  name: 'submit-button',
  mixins: [Button, DynamicProps],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    textOrDefault() {
      return this.text || this.$t('text');
    },
  },
  i18n: {
    messages: {
      de: {
        text: 'Speichern',
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// SubmitButton.vue?f2d4d8d8